<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
  export default {
    name: 'App'
  }
</script>

<style>
  html, body {
    height: 100%;
    background: #eeeeee;
  }

  #app {
    width: 7.5rem;
    margin: 0 auto;
    background: #eeeeee;
    height: 100%;
  }

  input {
    background: none;
    outline: none;
    border: none;

  }

  input:focus {
    border: none;
  }

  .top-page-all {
    height: .8rem;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 .32rem;
    background: #ffffff;
    position: relative;
  }
  .ret-btn {
    position: absolute;
    left: .42rem;
    line-height: .8rem;
    font-size: .32rem;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue